module.exports = __webpack_public_path__ + "img/Carrousels STARTO – après rdv_slide_1.d08807a2.png";